import { Box, Typography, styled } from '@mui/material';

export const SeveritySectionWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.625rem',
  alignSelf: 'stretch',
  width: '100%',
}));

export const SectionHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  display: 'flex',
  padding: '0.3125rem 0.625rem 0.3125rem 0.9375rem',
  alignItems: 'center',
  gap: '0.625rem',
  alignSelf: 'stretch',
  borderRadius: '0.625rem',
  background: '#FFF',
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '0.25rem',
    borderRadius: '0 6.25rem 6.25rem 0',
    backgroundColor: color,
  },
}));

export const IconWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const HeaderText = styled(Typography)(() => ({
  color: 'var(--Typography-h-tertiary, #615E6F)',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.625rem',
  flex: '1 0 0',
}));
